import * as React from 'react'
import * as styles from './dotted-divider.scss'

export const DottedDivider = () => <div className={styles.root} />
